import React from "react";

const About = () => {
  return <div> Sample About page</div>;
};

export default About;
